import React, { Component } from "react";
import { Empty, Spin, Select } from "antd";
import { LeftOutlined, RightOutlined, ReloadOutlined, CalendarOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, DatePickerItem, SelectItem, MensajeError } from "../../../../../Components/Items";
import PlaneacionPresupuestoPU from "./PlaneacionPresupuestoPU";
import { estiloBarraFiltros } from "./planeacion.utils";
import BotonReporteDiaProduccionPU from "./BotonReporteDiaProduccionPU";
import BotonPlanProduccionPU from "./BotonPlanProduccionPU";
import BotonParoLineaPU from "../../TiemposMuertosPU/BotonParoLineaPU";

const estiloNavegador = {
  display: "inline-flex",
  alignItems: "center",
  height: 32,
  border: "1px solid #d9d9d9",
  borderRadius: 8,
  background: "white",
  overflow: "hidden",
};
const estiloFlecha = { border: "none", boxShadow: "none", height: 30, width: 32, borderRadius: 0 };

moment.locale("es");

const REFRESCO_MS = 60 * 1000;

const UNIDAD_RANGO = {
  dia: { rango: "day", paso: "day", picker: "date", formato: "DD/MM/YYYY", ancho: 140 },
  semana: { rango: "isoWeek", paso: "week", picker: "week", formato: "[Semana] w · YYYY", ancho: 170 },
  mes: { rango: "month", paso: "month", picker: "month", formato: "MMMM YYYY", ancho: 160 },
  trimestre: { rango: "quarter", paso: "quarter", picker: "quarter", formato: "YYYY-[T]Q", ancho: 140 },
};

class PlaneacionProduccionPU extends Component {
  intervalo = null;
  state = {
    loading: false,
    grupos: [],
    presupuestosDisponibles: [],
    flujosDisponibles: [],
    presupuestoPUId: undefined,
    flujoId: undefined,
    ahora: null,
    modo: "dia",
    criterio: "planeadas",
    fecha: moment(),
  };

  componentDidMount() {
    this.consultar();
    this.intervalo = setInterval(() => this.consultar(true), REFRESCO_MS);
    document.addEventListener("visibilitychange", this.alCambiarVisibilidad);
  }

  componentWillUnmount() {
    clearInterval(this.intervalo);
    document.removeEventListener("visibilitychange", this.alCambiarVisibilidad);
  }

  alCambiarVisibilidad = () => {
    if (document.visibilityState === "visible") this.consultar(true);
  };

  rango = () => {
    if (this.state.modo === "todas") return { desde: null, hasta: null };
    const unidad = UNIDAD_RANGO[this.state.modo].rango;
    return { desde: this.state.fecha.clone().startOf(unidad), hasta: this.state.fecha.clone().endOf(unidad) };
  };

  consultar = (silencioso = false) => {
    const { desde, hasta } = this.rango();
    if (!silencioso) this.setState({ loading: true });
    axios
      .post(
        "ordenesDeProduccionPU/planeacionOrdenes",
        {
          empresaId: this.props.empresaId,
          desde: desde ? desde.toDate() : undefined,
          hasta: hasta ? hasta.toDate() : undefined,
          presupuestoPUId: this.state.presupuestoPUId,
          flujoId: this.state.flujoId,
          soloPlaneadas: this.soloPlaneadas(),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            grupos: res.data.grupos || [],
            presupuestosDisponibles: res.data.presupuestosDisponibles || [],
            flujosDisponibles: res.data.flujosDisponibles || [],
            ahora: res.data.ahora,
          });
        } else if (!silencioso) {
          MensajeError({ message: res.data.error || "No se pudo cargar la planeación" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        if (!silencioso) MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  soloPlaneadas = () => this.state.modo !== "todas" && this.state.criterio === "planeadas";

  cambiarModo = (modo) => this.setState({ modo }, () => this.consultar());

  cambiarFecha = (fecha) => fecha && this.setState({ fecha: moment(fecha) }, () => this.consultar());

  moverRango = (paso) =>
    this.setState(
      (prev) => ({ fecha: prev.fecha.clone().add(paso, UNIDAD_RANGO[prev.modo].paso) }),
      () => this.consultar()
    );

  etiquetaRango = () => {
    const { desde, hasta } = this.rango();
    if (this.state.modo === "todas") return "Todas las órdenes activas";
    if (this.state.modo === "dia") return desde.format("dddd DD [de] MMMM");
    if (this.state.modo === "mes") return desde.format("MMMM YYYY");
    if (this.state.modo === "trimestre") return `Trimestre ${desde.format("Q")} ${desde.format("YYYY")} (${desde.format("MMM")} - ${hasta.format("MMM")})`;
    return `${desde.format("DD MMM")} - ${hasta.format("DD MMM YYYY")}`;
  };

  renderControles() {
    const unidad = UNIDAD_RANGO[this.state.modo] || UNIDAD_RANGO.dia;
    return (
      <div style={estiloBarraFiltros}>
        <SegmentedItem
          options={[
            { label: "Día", value: "dia" },
            { label: "Semana", value: "semana" },
            { label: "Mes", value: "mes" },
            { label: "Trimestre", value: "trimestre" },
            { label: "Todas", value: "todas" },
          ]}
          value={this.state.modo}
          onChange={this.cambiarModo}
        />
        {this.state.modo !== "todas" && (
        <div style={estiloNavegador}>
          <ButtonItem type="text" style={estiloFlecha} icon={<LeftOutlined />} onClick={() => this.moverRango(-1)} />
          <DatePickerItem
            sinBorde
            value={this.state.fecha}
            picker={unidad.picker}
            format={unidad.formato}
            allowClear={false}
            suffixIcon={<CalendarOutlined style={{ color: "#8c8c8c" }} />}
            onChange={this.cambiarFecha}
            style={{ width: unidad.ancho, borderLeft: "1px solid #f0f0f0", borderRight: "1px solid #f0f0f0", height: 30 }}
          />
          <ButtonItem type="text" style={estiloFlecha} icon={<RightOutlined />} onClick={() => this.moverRango(1)} />
        </div>
        )}
        {this.state.modo !== "todas" && (
          <ButtonItem blanco botonAncho onClick={() => this.cambiarFecha(moment())}>
            Hoy
          </ButtonItem>
        )}
        {this.state.modo !== "todas" && (
          <SegmentedItem
            options={[
              { label: "Planeadas", value: "planeadas" },
              { label: "Con actividad", value: "actividad" },
            ]}
            value={this.state.criterio}
            onChange={(criterio) => this.setState({ criterio }, () => this.consultar())}
          />
        )}
        <SelectItem
          allowClear
          placeholder="Flujo"
          width={200}
          value={this.state.flujoId}
          onChange={(flujoId) => this.setState({ flujoId }, () => this.consultar())}
        >
          {this.state.flujosDisponibles.map((flujo) => (
            <Select.Option key={flujo._id} value={flujo._id}>
              {flujo.nombre}
            </Select.Option>
          ))}
        </SelectItem>
        <SelectItem
          allowClear
          placeholder="Presupuesto"
          width={220}
          value={this.state.presupuestoPUId}
          onChange={(presupuestoPUId) => this.setState({ presupuestoPUId }, () => this.consultar())}
        >
          {this.state.presupuestosDisponibles.map((presupuesto) => (
            <Select.Option key={presupuesto._id} value={presupuesto._id}>
              {presupuesto.nombre}
            </Select.Option>
          ))}
        </SelectItem>
        <span style={{ color: "#1a3a4a", fontWeight: 600, textTransform: "capitalize" }}>{this.etiquetaRango()}</span>
        <div style={{ flex: 1 }} />
        <BotonReporteDiaProduccionPU
          desde={this.rango().desde ? this.rango().desde.toDate() : undefined}
          hasta={this.rango().hasta ? this.rango().hasta.toDate() : undefined}
          etiquetaRango={this.etiquetaRango()}
          presupuestoPUId={this.state.presupuestoPUId}
          flujoId={this.state.flujoId}
          soloPlaneadas={this.soloPlaneadas()}
        />
        <BotonPlanProduccionPU
          desde={this.rango().desde ? this.rango().desde.toDate() : undefined}
          hasta={this.rango().hasta ? this.rango().hasta.toDate() : undefined}
          etiquetaRango={this.etiquetaRango()}
          presupuestoPUId={this.state.presupuestoPUId}
          flujoId={this.state.flujoId}
          soloPlaneadas={this.soloPlaneadas()}
        />
        <BotonParoLineaPU />
        <ButtonItem botonAncho naranja icon={<ReloadOutlined />} onClick={() => this.consultar()}>
          Actualizar
        </ButtonItem>
      </div>
    );
  }

  render() {
    const { grupos, loading, ahora, presupuestoPUId } = this.state;
    const rango = this.rango();

    return (
      <Spin spinning={loading}>
        {this.renderControles()}
        {grupos.length === 0 ? (
          <div style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" }}>
            <Empty description="No hay órdenes de producción activas para planear" />
          </div>
        ) : (
          grupos.map((grupo) => (
            <div
              key={grupo._id}
              style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)", marginBottom: 12 }}
            >
              <PlaneacionPresupuestoPU
                presupuesto={grupo}
                presupuestoFiltroId={presupuestoPUId}
                soloPlaneadas={this.soloPlaneadas()}
                ahora={ahora}
                etiquetaRango={this.etiquetaRango()}
                rango={{ desde: rango.desde ? rango.desde.toDate() : undefined, hasta: rango.hasta ? rango.hasta.toDate() : undefined }}
                onVer={this.props.onVer}
                onVerEtapas={this.props.onVerEtapas}
                onVerPdf={this.props.onVerPdf}
                onRefrescar={() => this.consultar(true)}
                permisoMoverPiezas={this.props.permisoMoverPiezas}
                permisoEditar={this.props.permisoEditar}
              />
            </div>
          ))
        )}
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(PlaneacionProduccionPU);
